import React from 'react';

const SectionSubject = ({ title, setTitle, titleError, setTitleError }) => {
  return (
    <section id="crafan_details">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          プロジェクトの内容
        </p>
      </div>
      <div className="shadow-sm pb-3 bg-white">
        <div className="container col-md-8 col-lg-6">
          <div className="row justify-content-between align-items-center">
            <p className="col-5 text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              プロジェクト名
              <span className="text-fz-14px text-fw-bold text-gray mb-2 mt-1 ml-2 d-inline-block">
                必須
              </span>
            </p>
          </div>
          <input
            id="title"
            className={`p-1 w-100 form-control ${titleError ? 'is-invalid' : ''}`}
            value={title}
            onChange={e => {
              setTitle(e.target.value);
              setTitleError(!e.target.value.trim());
            }}
            placeholder="プロジェクト名を入力してください"
            rows="3"
          />
          {titleError && (
            <div className="invalid-feedback">この項目は必須入力です。</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SectionSubject;
